import axios from 'axios';

const apiIstikhara = axios.create({
  baseURL: `https://api.alquran.cloud/v1/page`,
});

export default apiIstikhara;